module.exports = "/packs/002-6e30b737d76df14298c500a4761d1dc3.jpg";